import DOMPurify from "dompurify";

/**
 * Sanitize an HTML string before passing to dangerouslySetInnerHTML.
 * Defense-in-depth: our HTML is currently all static (no user input),
 * but running every html payload through DOMPurify prevents regressions
 * if a future refactor ever interpolates untrusted data into the string.
 */
export function sanitizeHtml(html) {
  if (!html) return { __html: "" };
  return {
    __html: DOMPurify.sanitize(html, {
      // Allow typical landing-page markup only.
      ALLOWED_TAGS: [
        "p", "br", "span", "div", "strong", "em", "b", "i", "u", "a",
        "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6",
        "blockquote",
      ],
      ALLOWED_ATTR: ["href", "target", "rel", "class"],
      ALLOW_DATA_ATTR: false,
    }),
  };
}
